import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../../../../core/services/quote.service';
import { IInhouseQuote, IInHouseQuoteLbl, IInvoiceInquiry, IPrintMaterialProposalBody } from '../../../../core/models';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../../core/common';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { formatDate, CurrencyPipe } from '@angular/common';
import { CommonService } from '../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { UserService } from '../../../../core/services/user.service';
let workbook: ExcelProper.Workbook = new Excel.Workbook();
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from '../../../../core/enums/NotifyType';

@Component({
  selector: 'app-in-house-quotes',
  templateUrl: './in-house-quotes.component.html',
  styleUrls: ['./in-house-quotes.component.scss']
})
export class InHouseQuotesComponent implements OnInit {
  inHouseQuoteGridData: GridDataResult;
  public gridData: IInhouseQuote[] = [];
  loadingPDF: boolean;
  loadingExcel: boolean;

  constructor(private quoteService: QuoteService, private persistingService: StatePersistingService, private commonService: CommonService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService, private appNotifyService: AppNotifyService) {
    const gridSettings: GridSettings = this.persistingService.get(this.userService.readUserObject.userName + 'inHouseGridSettings');

    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
    }
  }
  statusData = [];
  leedData = [];
  blastData = [];
  inHouseGridLoading: boolean = true;
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.loadInHouseGrid();
    this.loadHeaderFilterDropdownData();
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "inHouseQuoteLbl" },
      { controlName: "jobNumberLbl" },
      { controlName: "revlbl" },
      { controlName: "jobNameLbl" },
      { controlName: "leedLbl" },
      { controlName: "blastLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "quoteDateLbl" },
      { controlName: "expirationDateLbl" },
      { controlName: "totalBaseBidLbl" },
      { controlName: "statusLbl" },
      { controlName: "customerContactLbl" },
      { controlName: "statusTextLbl" },
      { controlName: "estimatorLbl" },
      { controlName: "orderDateLbl" },
      { controlName: "printLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "customerIdLbl" },
      { controlName: "customerNumberLbl" },
      { controlName: "customerNameLbl" },

    ];
    const componentName = "InHouseQuote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.inHouseTxt = response[response.length - 1];
      console.log(response);
      this.initializeGridHeader();
    }
  }
  inHouseTxt: IInHouseQuoteLbl = {
    inHouseQuoteLbl: "",
    jobNumberLbl: "",
    revlbl: "",
    jobNameLbl: "",
    leedLbl: "",
    blastLbl: "",
    marketSegmentLbl: "",
    quoteDateLbl: "",
    expirationDateLbl: "",
    totalBaseBidLbl: "",
    statusLbl: "",
    customerContactLbl: "",
    statusTextLbl: "",
    estimatorLbl: "",
    printLbl: "",
    exportToPdfLbl: "",
    exportToExcelLbl: "",
    customerIdLbl: "",
    customerNumberLbl : "",
    customerNameLbl: "",

  }
  //#endregion
  //#region Grid filter dropdown
  public loadHeaderFilterDropdownData() {
    this.statusData = [
      { name: 'Quote Received', value: 'Quote Received' },
      { name: 'In Process', value: 'In Process' },
      { name: 'Quote Sent', value: 'Quote Sent' },
      { name: 'No Bid', value: 'No Bid' }
    ];
    this.leedData = [{ name: 'Yes', value: true }, { name: 'No', value: false }];
    this.blastData = [{ name: 'Yes', value: false }, { name: 'No', value: false }];
  }
  //#endregion
  //#region Grid data binding
  public loadInHouseGrid(): void {
    //call service here and fetch the grid data
    //Put loader here
    this.inHouseGridLoading = true;
    this.quoteService.getAllInhouseQuotes().subscribe((response: Array<IInhouseQuote>) => {
      console.log(response);
      this.gridData = response.map((obj) => {
        obj.quoteDateAsDate = obj.quoteDate ? new Date(obj.quoteDate) : null;
        obj.quoteExpirationDateAsDate = obj.quoteDate ? new Date(obj.quoteExpirationDate) : null;
        return obj;
      });
      this.loadInHouseGridData();
      this.inHouseGridLoading = false;
    });
  }
  //#endregion
  //#region label declaration
  public inHouseGrid = {
    inHouseQuoteLbl: 'In-House Quote',
    jobNumberLbl: 'Job Number',
    revlbl: 'Rev #',
    jobNameLbl: 'Job Name',
    totalBaseBidLbl: 'Total Base Bid',
    quoteDateLbl: 'Quote Date',
    expirationDateLbl: 'Quote Expiration Date',
    marketSegmentLbl: 'Market Segment',
    customerContactLbl: 'Customer Contact',
    statusLbl: 'Status',
    leedLbl: 'LEED',
    blastLbl: 'Blast',
    estimatorLbl: 'Estimator',
    statusTextLbl: 'Status Text',
    printLbl: 'Print',
    exportToPdfLbl: "Export to PDF",
    exportToExcelLbl: "Export to Excel",
    customerIdLbl: "Customer Id",
    customerNumberLbl: "Customer Number",
    customerNameLbl: "Customer Name",
  };
  //#endregion
  //print icon click
  printMaterialProposal(quote: IInhouseQuote) {
    quote.downloadInProgress = true;
    //Make an service call here
    const body: IPrintMaterialProposalBody = {
      quoteCommonId: quote.quoteCommonId,
      contactFullName: "",
      contactEmail: "",
      userName: this.userService.readUserObject.userName
    }
    this.quoteService.printInHouseMaterialProposal(body).subscribe((response: any) => {
      if (response) {
        const linkSource = 'data:application/pdf;base64,' + response.urlPath;
        const downloadLink = document.createElement("a");
        const fileName = body.quoteCommonId + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
      }
      quote.downloadInProgress = false;
    });
  }

  //#region pagination, sorting,filtering for in house quote grid

  public inHouseGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'quoteNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  defaultSort = [{
    field: 'quoteNumber',
    dir: 'desc'
  }];

  public gridSettings: GridSettings = {
    state: this.inHouseGridstate,
    gridData: process(this.gridData, this.inHouseGridstate),
    columnsConfig: [{
      field: 'jobNumber',
      title: this.inHouseTxt.jobNumberLbl ? this.inHouseTxt.jobNumberLbl : this.inHouseGrid.jobNumberLbl,
      filterable: true
    }, {
      field: 'revision',
      title: this.inHouseTxt.revlbl ? this.inHouseTxt.revlbl : this.inHouseGrid.revlbl,
      filterable: true
    }, {
      field: 'jobName',
      title: this.inHouseTxt.jobNameLbl ? this.inHouseTxt.jobNameLbl : this.inHouseGrid.jobNameLbl,
      filterable: true
    }, {
      field: 'leed',
      title: this.inHouseTxt.leedLbl ? this.inHouseTxt.leedLbl : this.inHouseGrid.leedLbl,
      filterable: true,
    }, {
      field: 'blast',
      title: this.inHouseTxt.blastLbl ? this.inHouseTxt.blastLbl : this.inHouseGrid.blastLbl,
      filterable: true,
    }, {
      field: 'marketSegment',
      title: this.inHouseTxt.marketSegmentLbl ? this.inHouseTxt.marketSegmentLbl : this.inHouseGrid.marketSegmentLbl,
      filterable: true
    }, {
      field: 'quoteDateAsDate',
      title: this.inHouseTxt.quoteDateLbl ? this.inHouseTxt.quoteDateLbl : this.inHouseGrid.quoteDateLbl,
      filter: 'date',
      format: '{0:d}',
      _width: 220,
      filterable: true
    }, {
      field: 'quoteExpirationDateAsDate',
      title: this.inHouseTxt.expirationDateLbl ? this.inHouseTxt.expirationDateLbl : this.inHouseGrid.expirationDateLbl,
      filter: 'date',
      format: '{0:d}',
      _width: 220,
      filterable: true
    }, {
      field: 'totalBaseBid',
      title: this.inHouseTxt.totalBaseBidLbl ? this.inHouseTxt.totalBaseBidLbl : this.inHouseGrid.totalBaseBidLbl,
      filterable: true
    }, {
      field: 'status',
      title: this.inHouseTxt.statusLbl ? this.inHouseTxt.statusLbl : this.inHouseGrid.statusLbl,
      filterable: true
    }, {
      field: 'customerContact',
      title: this.inHouseTxt.customerContactLbl ? this.inHouseTxt.customerContactLbl : this.inHouseGrid.customerContactLbl,
      filterable: true
    }, {
      field: 'statusReasonText',
      title: this.inHouseTxt.statusTextLbl ? this.inHouseTxt.statusTextLbl : this.inHouseGrid.statusTextLbl,
      filterable: true
    }, {
      field: 'estimatorEmail',
      title: this.inHouseTxt.estimatorLbl ? this.inHouseTxt.estimatorLbl : this.inHouseGrid.estimatorLbl,
      filterable: true
    }]
  };

  public loadInHouseGridData(): void {
    this.inHouseQuoteGridData = process(this.gridData, this.gridSettings.state);
    this.gridSettings.gridData = this.inHouseQuoteGridData;
  }

  public inHouseGridSortChange(sort): void {
    this.gridSettings.state.sort = sort;
    this.loadInHouseGridData();
  }

  public inHouseGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridSettings.state.skip = skip;
    this.gridSettings.state.take;
    this.loadInHouseGridData();
  }

  public inHouseDataStateChange(state: DataStateChangeEvent): void {
    this.gridSettings.state = state;
    this.loadInHouseGridData();
  }
  //#endregion
  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }
  public onResize(e: any): void {
    e.forEach(item => {
      this.gridSettings.columnsConfig.find(col => col.field === item.column.field).width = item.newWidth;
    });

    this.saveGrid();
  }

  public saveGrid(): void {
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };

    this.persistingService.set(this.userService.readUserObject.userName + 'inHouseGridSettings', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    this.mapDateFilter(state.filter);

    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.gridData, state)
    };
  }
  public mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      } else if (filter.field === 'FirstOrderedOn' && filter.value) {
        filter.value = new Date(filter.value);
      }
    });
  }
  //#region Export to PDF and Excel
  async generatePDF() {
    this.loadingPDF = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.inHouseTxt.inHouseQuoteLbl ? this.inHouseTxt.inHouseQuoteLbl : this.inHouseGrid.inHouseQuoteLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: this.inHouseTxt.customerNumberLbl ? this.inHouseTxt.customerNumberLbl : this.inHouseGrid.customerNumberLbl + ": " + this.userService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.inHouseTxt.customerNameLbl ? this.inHouseTxt.customerNameLbl : this.inHouseGrid.customerNameLbl + ": " + this.userService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.inHouseTxt.inHouseQuoteLbl ? this.inHouseTxt.inHouseQuoteLbl : this.inHouseGrid.inHouseQuoteLbl,
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            widths: [45, 25, 50, 30, 30, 50, 40, 40, 40, 40, 40, 30],
            body: [
              [
                this.inHouseTxt.jobNumberLbl ? this.inHouseTxt.jobNumberLbl : this.inHouseGrid.jobNumberLbl,
                this.inHouseTxt.revlbl ? this.inHouseTxt.revlbl : this.inHouseGrid.revlbl,
                this.inHouseTxt.jobNameLbl ? this.inHouseTxt.jobNameLbl : this.inHouseGrid.jobNameLbl,
                this.inHouseTxt.leedLbl ? this.inHouseTxt.leedLbl : this.inHouseGrid.leedLbl,
                this.inHouseTxt.blastLbl ? this.inHouseTxt.blastLbl : this.inHouseGrid.blastLbl,
                this.inHouseTxt.marketSegmentLbl ? this.inHouseTxt.marketSegmentLbl : this.inHouseGrid.marketSegmentLbl,
                this.inHouseTxt.quoteDateLbl ? this.inHouseTxt.quoteDateLbl : this.inHouseGrid.quoteDateLbl,
                this.inHouseTxt.expirationDateLbl ? this.inHouseTxt.expirationDateLbl : this.inHouseGrid.expirationDateLbl,
                //this.inHouseTxt.totalBaseBidLbl ? this.inHouseTxt.totalBaseBidLbl : this.inHouseGrid.totalBaseBidLbl,
                this.inHouseTxt.statusLbl ? this.inHouseTxt.statusLbl : this.inHouseGrid.statusLbl,
                this.inHouseTxt.customerContactLbl ? this.inHouseTxt.customerContactLbl : this.inHouseGrid.customerContactLbl,
                //this.inHouseTxt.statusTextLbl ? this.inHouseTxt.statusTextLbl : this.inHouseGrid.statusTextLbl,
                this.inHouseTxt.estimatorLbl ? this.inHouseTxt.estimatorLbl : this.inHouseGrid.estimatorLbl
              ],
              ...filterData.data.map(p =>
              ([
                p.jobNumber,
                p.revision ? p.revision : '',
                p.jobName ? p.jobName : '',
                p.leed ? "Y" : "N",
                p.blast ? "Y" : "N",
                p.marketSegment ? p.marketSegment : '',
                p.quoteDateAsDate ? p.quoteDateAsDate : '',
                p.quoteExpirationDateAsDate ? p.quoteExpirationDateAsDate : '',
                //p.totalBaseBid ? p.totalBaseBid : '$0.00',,
                p.status ? p.status : '',
                p.customerContact ? p.customerContact : '',
                /*p.statusReasonText ? p.statusReasonText : '',*/
                p.estimatorEmail ? p.estimatorEmail : ''
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('In-HouseQuote.pdf');
    this.loadingPDF = false;

  }

  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    let worksheet = workbook.addWorksheet('In-House Quote');
    const header = [
      this.inHouseTxt.jobNumberLbl ? this.inHouseTxt.jobNumberLbl : this.inHouseGrid.jobNumberLbl,
      this.inHouseTxt.revlbl ? this.inHouseTxt.revlbl : this.inHouseGrid.revlbl,
      this.inHouseTxt.jobNameLbl ? this.inHouseTxt.jobNameLbl : this.inHouseGrid.jobNameLbl,
      this.inHouseTxt.leedLbl ? this.inHouseTxt.leedLbl : this.inHouseGrid.leedLbl,
      this.inHouseTxt.blastLbl ? this.inHouseTxt.blastLbl : this.inHouseGrid.blastLbl,
      this.inHouseTxt.marketSegmentLbl ? this.inHouseTxt.marketSegmentLbl : this.inHouseGrid.marketSegmentLbl,
      this.inHouseTxt.quoteDateLbl ? this.inHouseTxt.quoteDateLbl : this.inHouseGrid.quoteDateLbl,
      this.inHouseTxt.expirationDateLbl ? this.inHouseTxt.expirationDateLbl : this.inHouseGrid.expirationDateLbl,
      this.inHouseTxt.totalBaseBidLbl ? this.inHouseTxt.totalBaseBidLbl : this.inHouseGrid.totalBaseBidLbl,
      this.inHouseTxt.statusLbl ? this.inHouseTxt.statusLbl : this.inHouseGrid.statusLbl,
      this.inHouseTxt.customerContactLbl ? this.inHouseTxt.customerContactLbl : this.inHouseGrid.customerContactLbl,
      this.inHouseTxt.statusTextLbl ? this.inHouseTxt.statusTextLbl : this.inHouseGrid.statusTextLbl,
      this.inHouseTxt.estimatorLbl ? this.inHouseTxt.estimatorLbl : this.inHouseGrid.estimatorLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow([this.inHouseTxt.customerNumberLbl ? this.inHouseTxt.customerNumberLbl : this.inHouseGrid.customerNumberLbl + ": " + this.userService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow([this.inHouseTxt.customerNameLbl ? this.inHouseTxt.customerNameLbl : this.inHouseGrid.customerNameLbl + ": " + this.userService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['In-House Quote']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
    ([
      p.jobNumber,
      p.revision ? p.revision : '',
      p.jobName ? p.jobName : '',
      p.leed ? "Y" : "N",
      p.blast ? "Y" : "N",
      p.marketSegment ? p.marketSegment : '',
      p.quoteDateAsDate ? p.quoteDateAsDate : '',
      p.quoteExpirationDateAsDate ? p.quoteExpirationDateAsDate : '',
      p.totalBaseBid ? p.totalBaseBid : '$0.00',
      p.status ? p.status : '',
      p.customerContact ? p.customerContact : '',
      p.statusReasonText ? p.statusReasonText : '',
      p.estimatorEmail ? p.estimatorEmail : '',
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'InHouseQuote.xlsx');
    })
    this.loadingExcel = false;

  }
  
  public onFilterInHouseGrid(inputValue: string): void {

    this.gridSettings.gridData = process(this.gridData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "jobNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "jobName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "revision",
            operator: "contains",
            value: inputValue,
          },
          
          {
            field: "marketSegment",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "customerContact",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "statusReasonText",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "estimatorEmail",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "quoteDateAsDate",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "quoteExpirationDateAsDate",
            operator: "contains",
            value: inputValue,
          },

          {
            field: "status",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.gridSettings.state.skip = 0;
      this.gridSettings.state.take = 10;
      this.loadInHouseGridData();
    }
    //this.dataBinding.skip = 0;
  }

  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {

      if (el.field == 'jobNumber') {
        el.title = this.inHouseTxt.jobNumberLbl ? this.inHouseTxt.jobNumberLbl : this.inHouseGrid.jobNumberLbl;
      }
      if (el.field == 'revision') {
        el.title = this.inHouseTxt.revlbl ? this.inHouseTxt.revlbl : this.inHouseGrid.revlbl;

      }
      if (el.field == 'jobName') {
        el.title = this.inHouseTxt.jobNameLbl ? this.inHouseTxt.jobNameLbl : this.inHouseGrid.jobNameLbl;

      }
      if (el.field == 'leed') {
        el.title = this.inHouseTxt.leedLbl ? this.inHouseTxt.leedLbl : this.inHouseGrid.leedLbl;
      }
      if (el.field == 'blast') {
        el.title = this.inHouseTxt.blastLbl ? this.inHouseTxt.blastLbl : this.inHouseGrid.blastLbl;
      }
      if (el.field == 'marketSegment') {
        el.title = this.inHouseTxt.marketSegmentLbl ? this.inHouseTxt.marketSegmentLbl : this.inHouseGrid.marketSegmentLbl;

      }
      if (el.field == 'quoteDateAsDate') {
        el.title = this.inHouseTxt.quoteDateLbl ? this.inHouseTxt.quoteDateLbl : this.inHouseGrid.quoteDateLbl;
      }
      if (el.field == 'quoteExpirationDateAsDate') {
        el.title = this.inHouseTxt.expirationDateLbl ? this.inHouseTxt.expirationDateLbl : this.inHouseGrid.expirationDateLbl;

      }
      if (el.field == 'totalBaseBid') {
        el.title = this.inHouseTxt.totalBaseBidLbl ? this.inHouseTxt.totalBaseBidLbl : this.inHouseGrid.totalBaseBidLbl;

      }
      if (el.field == 'status') {
        el.title = this.inHouseTxt.statusLbl ? this.inHouseTxt.statusLbl : this.inHouseGrid.statusLbl;

      }
      if (el.field == 'customerContact') {
        el.title = this.inHouseTxt.customerContactLbl ? this.inHouseTxt.customerContactLbl : this.inHouseGrid.customerContactLbl;

      }
      if (el.field == 'statusReasonText') {
        el.title = this.inHouseTxt.statusTextLbl ? this.inHouseTxt.statusTextLbl : this.inHouseGrid.statusTextLbl;

      }
      if (el.field == 'estimatorEmail') {
        el.title = this.inHouseTxt.estimatorLbl ? this.inHouseTxt.estimatorLbl : this.inHouseGrid.estimatorLbl;

      }

    });
  }
}
